import React from "react";
import { Upload, X } from "lucide-react";
import { Q, Single, Multi, Text } from "./AudioFields";
import * as D from "../../data/audioQuote";

const today = () => new Date().toISOString().slice(0, 10);

const Files = ({ files, setFiles }) => (
  <div data-testid="aq-files">
    <label className="flex items-center justify-center gap-2 px-4 py-5 rounded-xl border-2 border-dashed border-slate-300 hover:border-[#3b9dff] cursor-pointer text-sm font-semibold text-[#0a1f44]">
      <Upload className="w-4 h-4 text-[#3b9dff]" /> Add room photos or videos (JPG, PNG, MP4, MOV, up to 5)
      <input type="file" multiple accept=".jpg,.jpeg,.png,.mp4,.mov,image/jpeg,image/png,video/mp4,video/quicktime" className="hidden" data-testid="aq-file-input"
        onChange={(e) => { setFiles([...files, ...Array.from(e.target.files)].slice(0, 5)); e.target.value = ""; }} />
    </label>
    {files.length > 0 && (
      <ul className="mt-2 space-y-1">
        {files.map((f, i) => (
          <li key={i} className="flex items-center justify-between text-xs text-slate-600 bg-slate-50 rounded-lg px-3 py-2" data-testid={`aq-file-${i}`}>
            <span className="truncate">{f.name}</span>
            <button type="button" onClick={() => setFiles(files.filter((_, j) => j !== i))} aria-label="Remove file"><X className="w-4 h-4" /></button>
          </li>
        ))}
      </ul>
    )}
  </div>
);

export const FinalStep = ({ a, set, files, setFiles }) => (
  <>
    {a.scope !== D.QUICK_SCOPE && (
      <Q title="Media sources" testid="aq-sources"><Multi options={D.SOURCES} value={a.sources} onChange={(v) => set({ sources: v })} testid="aq-source" cols="sm:grid-cols-3" /></Q>
    )}
    <Q title="How would you like your quote?" testid="aq-quote-option">
      <Single options={[D.QUOTE_A, D.QUOTE_B]} value={a.quoteOpt} onChange={(v) => set({ quoteOpt: v })} testid="aq-quote-opt" />
      <div className="mt-3">
        {a.quoteOpt === D.QUOTE_A && <Files files={files} setFiles={setFiles} />}
        {a.quoteOpt === D.QUOTE_B && (
          <div className="grid sm:grid-cols-2 gap-3" data-testid="aq-survey-time">
            <input type="date" min={today()} value={a.date} onChange={(e) => set({ date: e.target.value })} data-testid="aq-date" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-[#3b9dff] focus:outline-none text-sm" />
            <select value={a.slot} onChange={(e) => set({ slot: e.target.value })} data-testid="aq-slot" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-[#3b9dff] focus:outline-none text-sm bg-white">
              <option value="">Preferred arrival time</option>
              {D.SLOTS.map((s) => <option key={s}>{s}</option>)}
            </select>
          </div>
        )}
      </div>
    </Q>
    <Q title="Your contact details" testid="aq-contact">
      <div className="grid sm:grid-cols-2 gap-3">
        <Text placeholder="First name *" value={a.first} onChange={(e) => set({ first: e.target.value })} data-testid="aq-first" />
        <Text placeholder="Last name *" value={a.last} onChange={(e) => set({ last: e.target.value })} data-testid="aq-last" />
        <Text placeholder="Email *" type="email" value={a.email} onChange={(e) => set({ email: e.target.value })} data-testid="aq-email" />
        <Text placeholder="Phone *" type="tel" value={a.phone} onChange={(e) => set({ phone: e.target.value })} data-testid="aq-phone" />
      </div>
      <div className="mt-3 space-y-3">
        <Text placeholder="Service address" value={a.address} onChange={(e) => set({ address: e.target.value })} data-testid="aq-address" />
        <textarea placeholder="Anything else we should know? (optional)" value={a.notes} onChange={(e) => set({ notes: e.target.value })} data-testid="aq-notes" rows={3}
          className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-[#3b9dff] focus:outline-none text-sm" />
      </div>
    </Q>
  </>
);
